/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { getEventName } from '@e180/domain/lib/event/util';

import MarketSlackNotificationDumb from './MarketSlackNotificationDumb';
import { getSlackChannelName } from 'plugin/slack/util/slackUtils';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const mapStateToProps = (
  state: Object,
  { notification, intl }: Props,
): Object => {
  const event = getEventSafely(state);
  return {
    notification,
    eventName: getEventName(event, intl.locale),
    slackChannelName: getSlackChannelName(event),
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { notification }: Props,
): Object => ({
  ...stateProps,
  handleDismiss() {
    dispatch(dismissNotification(notification));
  },
});

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(MarketSlackNotificationDumb);
